import { render, staticRenderFns } from "./BldAdmEdit.vue?vue&type=template&id=44f4139f&scoped=true&"
import script from "./BldAdmEdit.vue?vue&type=script&lang=js&"
export * from "./BldAdmEdit.vue?vue&type=script&lang=js&"
import style0 from "./BldAdmEdit.vue?vue&type=style&index=0&id=44f4139f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4139f",
  null
  
)

export default component.exports